import Raven from 'raven-js';

export const logError = (error, { errorMessageFallback, tags, data } = {}) => {
  if (__DEVELOPMENT__) {
    if (errorMessageFallback) {
      // eslint-disable-next-line no-console
      console.error(errorMessageFallback);
    }
    // eslint-disable-next-line no-console
    console.error(error);
  }
  if (error instanceof Error) {
    Raven.captureException(error, { tags });
  } else {
    Raven.captureMessage(errorMessageFallback, {
      extra: {
        error,
        data,
      },
      tags,
    });
  }
};
